import { useEffect, useState } from 'react';

/** Sekunden seit `since` (Zeitstempel in ms), sekündlich aktualisiert. null = 0. */
export function useElapsedSeconds(since: number | null): number {
  const [now, setNow] = useState(() => Date.now());

  useEffect(() => {
    if (since === null) return;
    setNow(Date.now());
    const timer = window.setInterval(() => setNow(Date.now()), 1_000);
    return () => window.clearInterval(timer);
  }, [since]);

  return since === null ? 0 : Math.max(0, Math.floor((now - since) / 1_000));
}
